import React, { useRef } from 'react';
import ProductTile from './ProductTile';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ title, products = [] }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames('spotlight-products pt5 reveal', {
        revealed: isIntersected,
      })}
    >
      {title && (
        <section className="tc spotlight-products__title">
          <h2 className="serif--sm serif--md--md">{title}</h2>
        </section>
      )}
      <div className="spotlight-products__list df fw fdr pt2 pt5--md pt7--lg jcb">
        {products &&
          products.map(prod => (
            <ProductTile type="spotlight" key={prod.variantId} {...prod} />
          ))}
      </div>
    </section>
  );
};
